import { useEffect } from "react";
import floralWaters from ".././files/floral_waters.json";
import { addDefaultImg } from '../components/imageUtils';


function FloralWaters() {
  useEffect(() => {
    document.title = "Floral Waters - Deww Botanicals";
  }, []);

  return (
    <>
      {/* // Page Header Start */}
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/hydrosols_banner.jpg)`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Floral Waters</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a className="text-body"  Using target="_blank" without rel="noreferrer" href="javascript:void(0);">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item text-dark active" aria-current="page">
                Floral Waters
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* // Page Header End */}

      <div className="container-xxl py-4 py-md-5 container-fluid p-0 mb-5 wow fadeIn">
        <div className="container">
          <div className="row g-0 align-items-end">
            <div className="col-12">
              <p>
                Hydrosols are also called floral water; it is the water that is
                recovered during the steam distillation of Essential Oils. When
                the essential oils are distilled through steam distillation,
                water is condensed. Most of the volatile compounds are
                accumulated as Essential Oils.
              </p>

              <h3>Extraction Method of Floral Waters?</h3>
              <p>
                  Floral waters are extracted by distillation and source of
                  aromatic molecules, they will boost formulas by bringing
                  active water.
                </p>

              <h6 className="mb-0 mt-5">Basil Hydrosol</h6>
              <p className="mb-0">
                Basil hydrosol has grassy notes and is clear, water-soluble, and
                consists of exceedingly fresh characteristic basil aroma.
              </p>
              <p className="mb-0">
                Treat skin problems like acne, blackheads, and premature aging
              </p>
              <p className="mb-0">Treat insect bites</p>
              <h6 className="mb-0 mt-2">Chamomile Hydrosol</h6>
              <p className="mb-0">
                Chamomile water is used in homemade wipes for babies & young
                children as it is gentle on hands, face & sore bottoms.
              </p>
              <p className="mb-0">Minimize menstrual pain and grumpiness</p>
              <p className="mb-0">Treat diabetes and lowering blood sugar</p>
              <h6 className="mb-0 mt-2">Clary Sage Hydrosol</h6>
              <p className="mb-0">
                Clary sage hydrosol floral water is best for toners & cleansers.
                It is used for the treatment of spots, sores, cuts, grazes, and
                new piercings.
              </p>
              <p className="mb-0">Used as a makeup remover</p>
              <p className="mb-0">
                Use to Water Phase in Facials, Clay, Masks, Moisturizers, Skin
                Care formulations
              </p>

              <div className="section-header text-start mb-2 mt-5 ">
                <h2 className="mb-2">Range of Floral Waters</h2>
                
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="tab-1" className="tab-pane fade show p-0 active">
              <div className="row g-4">
                {floralWaters.map((oil, index) => {
                  return (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6 "
                      key={index}
                    >
                      <div className="product-item h-100">
                        <div className="position-relative bg-light overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src={oil.image}
                            onError={addDefaultImg}
                            alt={oil.name}
                          />
                          {/* <div className="bg-secondary rounded text-white position-absolute start-0 top-0 m-2 py-1 px-3 nBadge">
                            New
                          </div> */}
                        </div>
                        <div className="text-center p-1 p-md-4 mt-1">
                          <a className="d-block h6 mb-1" Using target="_blank" without rel="noreferrer" href="">
                            {oil.name}
                          </a>
                          <p>{oil.description}</p>
                          {/* <span className="text-primary me-1">$19.00</span>
                          <span className="text-body text-decoration-line-through">
                            $29.00
                          </span> */}
                        </div>
                        {/* <div className="d-flex border-top">
                                    <small className="w-100 text-center py-2">
                                    <Link to="/floralWaters" className="text-body"><i className="fa fa-eye text-primary me-2"></i> View detail</Link>
                                    </small>
                                    <small className="w-50 text-center py-2">
                                        <a className="text-body" Using target="_blank" without rel="noreferrer" href=""><i className="fa fa-shopping-bag text-primary me-2"></i>Add to cart</a>
                                    </small>
                                </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FloralWaters;
